import { FC } from 'react';
import { StickyStyled } from './sticky.styled';
import { IStickyProps } from './sticky.types';

export const Sticky: FC<IStickyProps> = ({ children, top = '0', ...props }) => {
  return (
    <StickyStyled $top={top} {...props}>
      {children}
    </StickyStyled>
  );
};
